const ROUTE_NAMES = {
  HOME: "/",
  START: "/start",
  RULES: "/rules",
};

export default ROUTE_NAMES;
